import { FC } from "react";
import { KTSVG, toAbsoluteUrl } from "../../_metronic/helpers";
import { useIntl } from "react-intl";
import { getFileType, getNameUrl, isFileUrl } from "../../functions/general";

interface FileAttachmentProps {
    url: string;
    index: number;
}

interface ImageAttachmentProps {
    url: string;
    index: number;
}

interface MultiAttachmentModalProps {
    title: string;
    url: string | string[];
    isVisible: boolean;
    onClose: () => void;
}

const FileAttachment: FC<FileAttachmentProps> = ({ url, index }) => (
    <div className="d-flex align-items-center border border-dashed border-gray-300 rounded ps-2 mb-3">
        {getFileType(url) === "pdf" ? (
            <img src={toAbsoluteUrl('/media/logos/pdf.png')} alt="" style={{ width: "20px" }} />
        ) : getFileType(url) === "doc" || getFileType(url) === "docx" ? (
            <img src={toAbsoluteUrl('/media/logos/doc.png')} alt="" style={{ width: "20px" }} />
        ) : getFileType(url) === "ppt" || getFileType(url) === "pptx" ? (
            <img src={toAbsoluteUrl('/media/logos/ppt.png')} alt="" style={{ width: "20px" }} />
        ) : getFileType(url) === "xlsx" || getFileType(url) === "xls" ? (
            <img src={toAbsoluteUrl('/media/logos/xls.png')} alt="" style={{ width: "20px" }} />
        ) : (
            <img src={toAbsoluteUrl('/media/logos/file.png')} alt="" style={{ width: "20px" }} />
        )}
        <a key={index} href={url} className="m-3" target="_blank" rel="noopener noreferrer">
            {getNameUrl(url)}
        </a>
    </div>
);

const ImageAttachment: FC<ImageAttachmentProps> = ({ url, index }) => (
    <div className="d-flex align-items-center border border-dashed border-gray-300 rounded ps-2 mb-3">
        <img src={toAbsoluteUrl('/media/logos/image.png')} alt="" style={{ width: "20px" }} />
        <a key={index} href={url} className="m-3" target="_blank" rel="noopener noreferrer">
            {getNameUrl(url)}
        </a>
    </div>
);

const MultiAttachmentModal: FC<MultiAttachmentModalProps> = ({ title, url, isVisible, onClose }) => {
    const intl = useIntl();

    if (!isVisible) return null;

    return (
        <div
            className="modal fade show"
            tabIndex={-1}
            style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
            onClick={onClose}
        >
            <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h3 className="modal-title">{title}</h3>
                        <div
                            className="btn btn-icon btn-sm btn-active-light-primary ms-2"
                            onClick={onClose}
                            style={{ cursor: 'pointer' }}
                        >
                            <KTSVG
                                path="/media/icons/duotune/arrows/arr061.svg"
                                className="svg-icon svg-icon-2x"
                            />
                        </div>
                    </div>
                    <div className="modal-body">
                        {typeof url === "string" ? (
                            <img src={url} alt={title} className="img-fluid" />
                        ) : (
                            <>
                                {isFileUrl(url[0]) ? (
                                    url.map((data: string, index: number) => (
                                        <FileAttachment key={index} url={data} index={index} />
                                    ))
                                ) : (
                                    url.map((data: string, index: number) => (
                                        <ImageAttachment key={index} url={data} index={index} />
                                    ))
                                )}
                            </>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={onClose}
                        >
                            {intl.formatMessage({ id: "FORM.ACTION.CLOSE" })}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MultiAttachmentModal; 